var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('Header',{attrs:{"pageTitle":''}}),_c('div',{staticClass:"list-box"},_vm._l((_vm.list),function(item){return _c('BkItem',{key:item.id,staticClass:"bk-list-item",attrs:{"cover":item.coverImg,"name":item.name},nativeOn:{"click":function($event){return _vm.toDetail(item.id)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }